const ACCENT      = "#00C9FF";
const TRUE_COLOR  = "#00cc66";
const FAKE_COLOR  = "#ff3355";

export default function FactOrFakePlayer({ fact, selected, result, timeLeft, onAnswer }) {
  const answered  = selected !== null;
  const isCorrect = result && selected === result.is_true;
  const timerColor = timeLeft > 5 ? ACCENT : FAKE_COLOR;

  if (!fact) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "2rem" }}>
      <div style={{ color: ACCENT, fontFamily: "var(--font-body)", fontSize:"var(--fs-md)" }}>Загрузка...</div>
    </div>
  );

  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      gap: "1rem", padding: "1rem", width: "100%", maxWidth: "400px", margin: "0 auto",
    }}>

      {/* Таймер */}
      <div style={{
        width: "3rem", height: "3rem", borderRadius: "9999px",
        background: timerColor,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize:"var(--fs-xl)", fontWeight: "bold", color: "#000",
        boxShadow: `0 0 14px ${timerColor}`, transition: "background 0.3s",
      }}>
        {timeLeft}
      </div>

      {/* Факт */}
      <div style={{
        background: "#111", border: `2px solid ${ACCENT}`, borderRadius: "1.2rem",
        padding: "1.2rem", textAlign: "center", fontSize:"var(--fs-lg)", color: "#fff",
        fontFamily: "var(--font-heading)", lineHeight: 1.4, width: "100%",
        boxShadow: `0 0 20px ${ACCENT}33`,
      }}>
        {fact}
      </div>

      {/* Кнопки / результат */}
      {!result ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "0.7rem", width: "100%" }}>
          <button
            onClick={() => onAnswer(true)}
            disabled={answered}
            style={{
              background: selected === true ? `${TRUE_COLOR}44` : "#1a1a1a",
              border: `2px solid ${selected === true ? TRUE_COLOR : TRUE_COLOR + "66"}`,
              borderRadius: "1rem", padding: "1.1rem", color: TRUE_COLOR,
              fontFamily: "var(--font-heading)", fontSize:"var(--fs-xl)", fontWeight: "bold",
              width: "100%", cursor: answered ? "default" : "pointer", transition: "all 0.2s",
              WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
            }}>
            ✅ ПРАВДА
          </button>
          <button
            onClick={() => onAnswer(false)}
            disabled={answered}
            style={{
              background: selected === false ? `${FAKE_COLOR}44` : "#1a1a1a",
              border: `2px solid ${selected === false ? FAKE_COLOR : FAKE_COLOR + "66"}`,
              borderRadius: "1rem", padding: "1.1rem", color: FAKE_COLOR,
              fontFamily: "var(--font-heading)", fontSize:"var(--fs-xl)", fontWeight: "bold",
              width: "100%", cursor: answered ? "default" : "pointer", transition: "all 0.2s",
              WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
            }}>
            ❌ ФЕЙК
          </button>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap:"var(--gap-md)", width: "100%" }}>
          <div style={{
            background: isCorrect ? `${TRUE_COLOR}33` : `${FAKE_COLOR}33`,
            border: `2px solid ${isCorrect ? TRUE_COLOR : FAKE_COLOR}`,
            borderRadius: "1rem", padding: "0.9rem", textAlign: "center", width: "100%",
            color: isCorrect ? TRUE_COLOR : FAKE_COLOR,
            fontFamily: "var(--font-heading)", fontSize:"var(--fs-lg)", fontWeight: "bold",
          }}>
            {isCorrect ? "🎉 Правильно!" : "😔 Неверно"}
          </div>
          <div style={{
            background: "#111",
            border: `1px solid ${result.is_true ? TRUE_COLOR : FAKE_COLOR}55`,
            borderRadius: "0.8rem", padding: "0.7rem", textAlign: "center", width: "100%",
            color: result.is_true ? TRUE_COLOR : FAKE_COLOR,
            fontFamily: "var(--font-heading)", fontSize:"var(--fs-md)",
          }}>
            {result.is_true ? "✅ Это была ПРАВДА" : "❌ Это был ФЕЙК"}
          </div>
          {result.explanation && (
            <div style={{
              color: "#aaa", fontSize:"var(--fs-sm)", textAlign: "center",
              fontFamily: "var(--font-body)", lineHeight: 1.4, padding: "0 0.5rem",
            }}>
              {result.explanation}
            </div>
          )}
        </div>
      )}

      {answered && !result && (
        <div style={{ color: ACCENT, fontFamily: "var(--font-body)", fontSize:"var(--fs-sm)" }}>
          Ждём других игроков...
        </div>
      )}
    </div>
  );
}
